import { CategoryTypeValues, ServiceTypeDto, ServiceTypeValues } from './Services.types';

export const CATEGORY_NAME_OFFSET = '40px';

export const ALL_SERVICE_TYPES_KEY = 'ALL';

export const SERVICE_TYPE_LABELS: Record<ServiceTypeDto, string> = {
  [ServiceTypeValues.CARD]: 'Card service',
  [ServiceTypeValues.MANUAL_CLAIM]: 'Manual claim service',
  [ServiceTypeValues.HEALTH_PLAN]: 'Carrier claim service',
  [ServiceTypeValues.HIDDEN]: 'Hidden service',
};

export const SERVICE_TYPE_FILTER_OPTIONS = [
  { key: ALL_SERVICE_TYPES_KEY, value: 'All' },
  ...Object.entries(SERVICE_TYPE_LABELS).map(([key, value]) => ({ key, value })),
];

export const CATEGORY_LABELS: Record<string, string> = {
  [CategoryTypeValues.ADOPTION]: 'Adoption',
  [CategoryTypeValues.DENTAL]: 'Dental',
  [CategoryTypeValues.DEPENDENT_CARE]: 'Dependent Care',
  [CategoryTypeValues.MEDICAL]: 'Medical',
  [CategoryTypeValues.PARKING]: 'Parking',
  [CategoryTypeValues.PREMIUM]: 'Premium',
  [CategoryTypeValues.PHARMACY]: 'Pharmacy',
  [CategoryTypeValues.TRANSIT]: 'Transit',
  [CategoryTypeValues.VISION]: 'Vision',
  [CategoryTypeValues.LIFE_STYLE]: 'Life Style',
  [CategoryTypeValues.WELLNESS]: 'Wellness',
  [CategoryTypeValues.TRAVEL]: 'Travel',
  [CategoryTypeValues.PLAN_SPECIFIC]: 'Plan Specific',
};
